import CacheService from '../cache-service';
const axios = require('axios');

class NewslettersService extends CacheService {
  setNewsletters_id(newsletters) {
    return newsletters.map(newsletter => {
      return {
        ...newsletter,
        _id: newsletter.newsId || newsletter._id,               
      };
    });
  }
  
  getNewsletters(tag, page) {
    return this.getCachedData('/api/newsletters' + (tag ? `/ag/${tag}` : '') + (page ? `?page=${page}` : ''))
      .then((response) => {
        if (response.newsletters) {
          return {
            ...response,
            newsletters: this.setNewsletters_id(response.newsletters),
          }
        }
        
        return this.setNewsletters_id(response);
      });
  }

  getNewsletterById(id, tag) {
    return this.getCachedData('/api/newsletters' + (tag ? `/ag/${tag}` : '') + `/${id}`)
      .then((newsletter) => {
        return {
          ...newsletter,
          _id: newsletter.newsId || newsletter._id,               
        };
      });
  }

  generateNewsletterCandidate(dailyNewsIds, tag, postsNum) {
    const body = { daily_news_ids: dailyNewsIds, posts_num: postsNum };
    return axios.post('/api/newsletters' + (tag ? `/ag/${tag}` : '') + '/generate-candidate', body).then(res => res.data);
  }

  generateNewsletter(newsletter, tag) {
    const body = { ...newsletter };
    return axios.post('/api/newsletters' + (tag ? `/ag/${tag}` : '') + '/generate', body).then(res => res.data);
  }  

  getNewslettersTypes() {
    return this.getCachedData('/api/newsletters/types');   
  }
}

const newslettersService = new NewslettersService();

export default newslettersService;